import { render } from "./error503.vue?vue&type=template&id=ca3e50d0"
const script = {}

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__